<template>
  <div class="edit">
    <v-dialog v-model="dialog" width="500" persistent>
      <v-card>
            <v-card-title class="title grey lighten-2" primary-title>Edit Virtual Card Account</v-card-title>

            <v-card-text class="pt-3">
              
              <v-form ref="form" v-model="valid">

                <v-text-field v-model="cardHolder" :rules="nameRules" label="Card Holder (*)" required></v-text-field>

                <v-text-field v-model="cardNumber" :rules="nameRules" label="Card Number (*)" required></v-text-field>

                <v-text-field v-model="cvv" :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'" :rules="[rules.required]"
                    :type="show ? 'text' : 'password'"
                    label="Password (*)"
                    @click:append="show = !show"
                    required
                ></v-text-field>

                <v-dialog ref="dialog" v-model="modal" :return-value.sync="expireDate" width="290px">
                    <template v-slot:activator="{ on }">
                        <v-text-field v-model="expireDate" label="Expire Date (*)" readonly v-on="on"></v-text-field>
                    </template>
                    <v-date-picker color="blue-grey" v-model="expireDate" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
                        <v-btn text color="primary" @click="$refs.dialog.save(expireDate)">OK</v-btn>
                    </v-date-picker>
                </v-dialog>

                <v-text-field v-model="appCode" :rules="nameRules" label="App Code (*)" required></v-text-field>

                <v-text-field v-model="phone" :rules="nameRules" label="Phone Number (*)" required></v-text-field>

                <v-textarea v-model="remark" outlined label="Remark (Optional)"></v-textarea>

              </v-form>

            </v-card-text>

            <v-divider></v-divider>
            <v-card-actions>
                <v-btn dark @click="$emit('dialogHide')">Cancel</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="blue-grey white--text" :loading="isLoading" :disabled="!valid" @click="updateRecord">Save Update</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

  </div>
</template>

<script>
import { db, auth } from '@/plugins/appfirebase'
export default {

  props: [ 'dialog', 'recuid' ],

  created() {
    this.getRecord()
  },

  data() {
    return {

      cardHolder: '',
      cardNumber: '',
      cvv: '',
      expireDate: '',
      appCode: '',
      phone: '',
      remark: '',

      nameRules: [
        v => !!v || 'Name is required',
      ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      rules: {
          required: value => !!value || 'Required.'
      },
      valid: true,
      show: false,
      isLoading: false,
      modal: false,
      
      mydb: db.collection('vcard').doc(auth.currentUser.uid).collection('data')
    }
  },

  methods: {

    getRecord() {

      if (this.recuid) {
        
        this.mydb.doc(this.recuid).get()
          .then( docs => {

            let doc = docs.data();

            this.cardHolder = doc.card_holder,
            this.cardNumber = doc.card_number,
            this.cvv = doc.cvv,
            this.expireDate = doc.expire_date,
            this.appCode = doc.app_code,
            this.phone =  doc.phone,
            this.remark = doc.remark
          })
      }
      
    },

    updateRecord() {
      
      this.isLoading = true

      this.mydb.doc(this.recuid)
        .update({
          card_holder: this.cardHolder,
          card_number: this.cardNumber,
          cvv: this.cvv,
          expire_date: this.expireDate,
          app_code: this.appCode,
          phone: this.phone,
          remark: this.remark
        })
        .then( () => {
          this.isLoading = false
          this.$store.state.snackSuccess = true
          this.$emit('dialogHide');
        })
    }

  },

}
</script>

<style>

</style>